<div class="sky-card">
  <div class="sky-card-header">
    <h1 class="h2 mb-0">Items</h1>
  </div>
</div>

<!-- Categories -->
<div class="sky-card mt">
  <div class="sky-card-header">
    <h2 class="h3 mb-0">Type</h2>
  </div>
  <div class="sky-card-body">
    <app-item-type-selector [type]="type" (typeChanged)="onTypeChanged($event)"></app-item-type-selector>
  </div>
</div>

<!-- Items -->
<div class="sky-card mt" *ngIf="shownItems?.length">
  <div class="sky-card-header">
    <div class="unlock-bar">
      You have unlocked
      <b [class.completed]="shownUnlocked == shownItems.length">{{ shownUnlocked }}</b>
      out of
      <b [class.completed]="shownUnlocked == shownItems.length">{{ shownItems.length }}</b>
      items.
      <div class="none-toggle" [style.opacity]="(shouldShowNone ? 1 : 0.5)" (click)="toggleNone()">
        <mat-icon svgIcon="none" [ngbTooltip]="'Toggle unequip icon'" container="body" placement="left"></mat-icon>
      </div>
      <div class="column-toggle">
        <mat-icon (click)="setColumns()" [ngbTooltip]="'Toggle column size'" container="body" placement="left">apps</mat-icon>
      </div>
    </div>
  </div>

  <div class="sky-card-body">
    <div class="flex item-grid" [class.gap-half-y]="columns">
      <div class="item-icon" *ngIf="showNone">
        <div class="item-none">
          <mat-icon class="" svgIcon="none"></mat-icon>
        </div>
      </div>
      <ng-container *ngFor="let item of shownItems; let i = index">
        <div class="item-col-hr" [style.display]="!columns || !i || ((i+offsetNone) % (columns)) ? undefined : 'block'"></div>
        <div class="item-icon">
          <app-item [item]="item" [showSubIcons]="true" class="a"
            (click)="selectItem($event, item)"
            [class.highlight]="item && item === selectedItem"
            [class.item-unlocked]="item.unlocked && (item.type !== typeEmote || item.level! >= emoteLevels[item.name])"
            [ngbTooltip]="item.name" container="body" placement="auto" >
          </app-item>
          <mat-icon class="unlock-check" [class.self]="item.type !== typeEmote || item.level! >= emoteLevels[item.name]" [class.unlocked]="item.unlocked">done</mat-icon>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Selected item -->
<div #itemDiv [hidden]="!selectedItem" class="grid grid-1 item-info mt">
  <div class="sky-card" *ngIf="selectedItem">
    <div class="sky-card-header">
      <h2 class="h3">{{ selectedItem.name }}</h2>
    </div>
    <div class="sky-card-body">
      <div class="info-grid">
        <a class="item-icon item-icon-large info-grid-icon d-inline-block" [routerLink]="selectedItemNav?.route" [queryParams]="selectedItemNav?.extras?.queryParams">
          <app-item [item]="selectedItem" [size]="'large'" [highlight]="true" [hoverHighlight]="false"></app-item>
        </a>
        <app-wiki-link [wiki]="selectedItem._wiki" [aClass]="'info-grid-find container'"></app-wiki-link>
        <a *ngIf="selectedItemNav" class="info-grid-find container" [routerLink]="selectedItemNav.route" [queryParams]="selectedItemNav.extras?.queryParams">
          <mat-icon class="menu-icon">search</mat-icon>
          <span class="menu-label">Find item</span>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Field guide -->
<ng-container *ngIf="previewItems?.length">
  <div class="sky-card mt">
    <div class="sky-card-header header-previews" (click)="togglePreviews()">
      <h2 class="h3 mb-0">
        Field guide
        <mat-icon>{{showFieldGuide ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
      </h2>
    </div>
    <div class="sky-card-body" *ngIf="showFieldGuide">
      <div class="sky-flex flex-wrap" *ngIf="previewItems?.length">
        <ng-container *ngFor="let item of previewItems">
          <div *ngIf="item.previewUrl" (click)="openItem(item)"
          [class.highlight]="item && item === selectedItem"
            class="item-preview link" [ngbTooltip]="item.name" container="body" placement="auto">
            <div class="pad">
              <div class="item-preview-icon">
                <app-item [item]="item" [hoverHighlight]="false" [highlight]="true" [showSubIcons]="false"></app-item>
              </div>
              <div class="mt">
                <img [src]="item.previewUrl" class="preview-img" loading="lazy">
                <app-item-icons [item]="item"></app-item-icons>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
